import {
  getCoacOrigin,
  getDisputesOrigin,
  getMgoOrigin,
} from '../utils/destinationManager';

export default {
  coacUrl: getCoacOrigin(window.location.href),
  disputesUrl: `${getDisputesOrigin(window.location.href)}/mgoc/disputes`,
  mgoUrl: getMgoOrigin(window.location.href),
};
